/* eslint-disable no-restricted-syntax */
/* eslint-disable no-cond-assign */
/* eslint-disable no-continue */
/* eslint-disable consistent-return */

// Crude datetime pattern match.. can't use ISO8601 because service
// is also returning some numeric values, e.g. usage data, as strings
// eslint-disable-next-line no-useless-escape
const pattern = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d{3})?$/;

const convertDateStringsToDates = (input) => {
  if (typeof input !== 'object') return input;

  for (const key in input) {
    if (!Object.prototype.hasOwnProperty.call(input, key)) continue;

    const value = input[key];
    let match;

    if (typeof value === 'string' && (match = value.match(pattern))) {
      // Date string is one day off when converted to date object, below code forces fix
      const d = new Date(match[0]);
      input[key] = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    } else if (typeof value === 'object') {
      convertDateStringsToDates(value);
    }
  }
};

/* @ngInject */
export default ($httpProvider) => {
  $httpProvider.defaults.transformResponse.push((response) => {
    convertDateStringsToDates(response);
    return response;
  });
};



// WEBPACK FOOTER //
// ./config/http-transform.js